import { useLocalizationContext } from '../components/LocalizationProvider'

/**
 * React Hook for Localization
 * 
 * Provides language state and translation functions for components
 * Uses shared context so language changes propagate to all components
 */
export function useLocalization() {
  return useLocalizationContext()
}
